export const DyEventName = {
    SYNC_CART: 'Sync cart',
    ADD_TO_CART: 'Add to Cart',
    REMOVE_FROM_CART: 'Remove from Cart',
    PURCHASE: 'Purchase',
    IDENTIFY: 'Identify',
    LOGIN: 'Login',
    SIGNUP: 'Signup',
} as const;

export const DyEventType = {
    SYNC_CART: 'sync-cart-v1',
    ADD_TO_CART: 'add-to-cart-v1',
    REMOVE_FROM_CART: 'remove-from-cart-v1',
    PURCHASE: 'purchase-v1',
    IDENTIFY: 'identify-v1',
    LOGIN: 'login-v1',
    SIGNUP: 'signup-v1',
} as const;

export const DY_CUID_TYPE_HASHED_EMAIL = 'he';

export type DyRecommendationContext = {
    type: string;
    lng: string;
    data?: string[];
};

declare global {
    interface Window {
        DY?: {
            recommendationContext?: DyRecommendationContext;
            userActiveConsent?: {accepted: boolean};
            API?: (type: string, params: Record<string, unknown>) => void;
        };
    }
}

export type DyEventProperties = Record<string, unknown> & {dyType: string};

export type DyEvent = {
    name: string;
    properties: DyEventProperties;
};

export type DyProductIdSource = {
    itemOptionId?: string | number | null;
    itemId?: string | number | null;
    digistyleId?: string | number | null;
};

export function toDyProductId(source: DyProductIdSource): string | null {
    const productId = source?.itemOptionId;
    if (productId === undefined || productId === null || productId === '') {
        return null;
    }
    return String(productId);
}

export function toDyPrice(value: string | number | null | undefined): number | null {
    if (value === null || value === undefined || value === '') {
        return null;
    }

    const parsed = typeof value === 'number' ? value : Number(String(value).replace(',', '.'));
    if (!Number.isFinite(parsed)) {
        return null;
    }

    return Math.round(parsed * 100) / 100;
}
